import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function Logistika() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Logistika" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Logistika</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Logistika
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj poslovne logistike se sastoji u povećanju efikasnosti
                poslovanja putem ubrzavanja cirkulacije angažovanih sredstava.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Učestvuje u timu koji osmišljava, upravlja i realizuje projektni
                zadatak; Koristi savremenu informacionu tehnologiju u poslovne
                svrhe; Demonstrira razumevanje finansijske funkcije i sposobnost
                donošenja odluka; Razvija praktične modele i strategije bazirane
                na savremenoj teoriji i praksi; Opisuje i kvantifikuje rizike,
                priprema koncizan i tačan izveštaj o upravljanju rizikom i
                primeni relevantne tehnike za upravljanje rizikom; Primeni
                teorijska i praktična znanja za procenu logističkih sistema,
                njihovo unapređenje i oblikovanje optimalnog logističkog sistema
                poslovnog subjekta.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>Teorijska nastava:</p>
              <ul>
                <li>
                  Istorijski aspekt logistike i tehničke logistike; Razvojno
                  aspekt logistike i tehnologije; Informacione tehnologije u
                  logistici; Nabavna logistika; Logističke aktivnosti i izbor
                  dobavljača; Logistika dobavljača, skladištenja i zaliha;
                  Logistika unutrašnjeg kretanja; Logistika distribucije i
                  isporuke; Obrnuta logistika; Logističke strategije
                </li>
              </ul>

              <p>
                <strong>Metode izvođenja nastave:</strong> Osnovni oblici rada
                na predmetu su: predavanja i vježbe, samostalni rad (seminarski
                rad i interaktivna nastava, samostalne zadatke uz primjenu
                multimedije i Interneta.)
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>Pojam i zadaci poslovne logistike</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Značaj logistike za povećanje uspješnosti poslovanja
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Organizacija preduzeća: osnov i okvir poslovne logistike
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>Preduzeće kao organizacioni sistem</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>Principi organizacije preduzeća</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>Osnovni oblici organizacione strukture</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>Logistički menadžment</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Logistički kontroling</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>Organizovanje funkcije poslovne logistike</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Logistika nabavke</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Nabavka kao činilac poslovnog uspjeha</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P + 2V</td>
                    <td>Logistika skladištenja</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>Pakovanje robe</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Logistika unutrašnjeg transporta</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>Kombinovani transport</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 345 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 215 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Logistika;
